<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-box"></i> 日常消耗借用</span>
      </div>

      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        label-position="right"
        label-width="70px"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20">
          <!-- 申请部门 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="申请部门">
              <el-select
                v-model="queryParams.departmentName"
                placeholder="请选择申请部门"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 申请人 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="申请人">
              <el-input
                v-model="queryParams.creatorName"
                placeholder="请输入申请人"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <!-- 状态 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="状态">
              <el-select
                v-model="queryParams.state"
                placeholder="请选择状态"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in borrowStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 发起时间 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="发起时间">
              <el-date-picker
                v-model="queryParams.applyTimeRange"
                type="daterange"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                clearable
                style="width: 100%"
                @change="handleDateChange"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 按钮区域 -->
        <div>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
          >
            搜索
          </el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button @click="handleExport">导出</el-button>
        </div>
      </el-form>

      <!-- 表格展示 -->
      <el-table
        :data="tableData"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column
          prop="departmentName"
          label="申请部门"
          width="120"
          fixed
        />
        <el-table-column prop="creatorName" label="申请人" width="120" fixed />
        <el-table-column prop="name" label="清单名称" width="160" fixed />
        <el-table-column prop="loanAssets" label="借用物资" width="180" />
        <el-table-column prop="useDate" label="使用时间" width="120" />
        <el-table-column prop="returnDate" label="归还时间" width="120" />
        <el-table-column prop="state" label="状态" width="120">
          <template slot-scope="scope">
            {{ formatBorrowStatus(scope.row.state) }}
          </template>
        </el-table-column>
        <el-table-column prop="approverName" label="审批人" width="120" />
        <el-table-column prop="approveState" label="审批状态" width="120">
          <template slot-scope="scope">
            {{ formatApprovalStatus(scope.row.approveState).label }}
          </template>
        </el-table-column>
        <el-table-column prop="rejectReason" label="驳回信息" width="180" />
        <el-table-column prop="issuerName" label="发放人" width="120" />
        <el-table-column
          prop="confirmReturnTime"
          label="确认归还时间"
          width="140"
        />
        <el-table-column prop="cc" label="抄送给" width="150" />
        <el-table-column prop="createTime" label="发起时间" width="160" />
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />
    </el-card>
  </div>
</template>

<script>
import {
  dailyAssetsLoanApplicationPage,
  dailyAssetsLoanApplicationExport,
} from "@/api/admin";
// import { departmentList } from "@/api/config.js";
import PaginationBar from "@/components/PaginationBar";
import { MAX_PAGE_SIZE } from "@/utils/const.js";
import { downloadFile } from "@/utils/util";
import { omit } from "lodash";
import { mapState } from "vuex";

export default {
  name: "ConsumableApplicationList",
  components: { PaginationBar },
  computed: {
    ...mapState(["departmentList"]), // 从 Vuex 获取 userPermissions
  },
  data() {
    return {
      selectedRows: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      queryParams: {
        creatorName: "",
        departmentName: "",
        state: "",
        applyTimeRange: [],
      },
      tableData: [],
      // departmentList: [], //部门
      borrowStatusOptions: [
        { label: "待审批", value: 0 },
        { label: "审批驳回", value: 2 },
        { label: "已取消", value: 3 },
        { label: "待发放", value: 4 },
        { label: "已发放（待领用）", value: 5 },
        { label: "已领用（待归还）", value: 6 },
        { label: "归还中", value: 7 },
        { label: "已归还", value: 8 },
      ],
      approvalStatusOptions: [
        { value: "-1", label: "等待前序审批", type: "info" },
        { value: "0", label: "待审批", type: "warning" },
        { value: "1", label: "审批通过", type: "success" },
        { value: "2", label: "审批驳回", type: "danger" },
      ],
      startCreateTime: "",
      endCreateTime: "",
    };
  },
  created() {
    this.handleQuery(1);
  },
  methods: {
    handleDateChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.startCreateTime = dateRange[0]; // "2025-05-30 00:00:00"
        this.endCreateTime = dateRange[1]; // "2025-06-02 23:59:59"
      } else {
        this.startCreateTime = "";
        this.endCreateTime = "";
      }
    },
    formatApprovalStatus(status) {
      const statusItem = this.approvalStatusOptions.find(
        (item) => item.value === String(status)
      );
      return statusItem || { label: "--", type: "" };
    },
    formatBorrowStatus(status) {
      const statusItem = this.borrowStatusOptions.find(
        (item) => Number(item.value) === status
      );
      return statusItem ? statusItem.label : "--";
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      // 处理多余的参数
      const param = omit(this.queryParams, ["applyTimeRange"]);
      dailyAssetsLoanApplicationPage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        startCreateTime: this.startCreateTime,
        endCreateTime: this.endCreateTime,
        ...param,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = {
        creatorName: "",
        departmentName: "",
        state: "",
        applyTimeRange: [],
      };
      this.startCreateTime = "";
      this.endCreateTime = "";
      this.handleQuery(1);
    },
    handleExport() {
      const exportData = this.tableData || [];

      if (exportData.length === 0) {
        this.$message.warning("没有可导出的数据");
        return;
      }

      const param = omit(this.queryParams, ["applyTimeRange"]);

      dailyAssetsLoanApplicationExport({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        startCreateTime: this.startCreateTime,
        endCreateTime: this.endCreateTime,
        ...param,
      }).then((res) => {
        downloadFile(
          res.data,
          "日常消耗借用数据.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
  },
};
</script>

<style scoped>
.app-container {
  .el-icon-document {
    margin-right: 5px;
  }
}
</style>
